import { useMemo, useState } from "react";
import { buildDailyPlanComparison, summarizeDailyPlanComparison } from "./production-daily-report-comparison";
import type { DailyPlanComparisonRow } from "./production-daily-report-comparison";
import type { SnapshotView, DailyReportFilter, DailyReportChartView } from "./public-daily-report-types";
import { publicDailyReportModel, rowId } from "./public-daily-report-presentation";

export function usePublicDailyReportWorkspace({ data }: { data: SnapshotView }) {
  const [selectedUnit, setSelectedUnit] = useState<string | null>(null);
  const [filter, setFilter] = useState<DailyReportFilter>("all");
  const [chartView, setChartView] = useState<DailyReportChartView>("shortage");
  const [productsOpen, setProductsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState<Set<string>>(new Set());
  const rows = useMemo(() => buildDailyPlanComparison(data.report.planRows, data.report.actualRows), [data.report]);
  const summaries = useMemo(() => summarizeDailyPlanComparison(rows), [rows]);
  const model = useMemo(() => publicDailyReportModel(data.report, rows, summaries, selectedUnit, filter, chartView, search), [data.report, rows, summaries, selectedUnit, filter, chartView, search]);
  const toggle = (key: string) => setExpanded((current) => {
    const next = new Set(current);
    if (next.has(key)) next.delete(key); else next.add(key);
    return next;
  });
  const openProduct = (row: DailyPlanComparisonRow) => {
    setSearch(""); setFilter("all"); setProductsOpen(true); setExpanded((current) => new Set([...current, row.key]));
    requestAnimationFrame(() => document.getElementById(rowId(row))?.scrollIntoView({ block: "center" }));
  };
  return { rows, summaries, filter, setFilter, chartView, setChartView, productsOpen, setProductsOpen, search, setSearch, expanded, setSelectedUnit, toggle, openProduct, ...model };
}
